import React, { PureComponent } from "react";
import PropTypes from "prop-types";

const withLoadChildrenMessages = Component =>
  class WithLoadChildrenMessages extends PureComponent {
    static propTypes = {
      childrenMessages: PropTypes.object,
      selectedMessage: PropTypes.object,
      getChildrenMessages: PropTypes.func.isRequired,
      rootMessages: PropTypes.object.isRequired,
      postMessageSuccess: PropTypes.func,
      postMessage: PropTypes.func,
    };

    constructor(props) {
      super(props);
      this.onPostMessageSuccess = this.onPostMessageSuccess.bind(this);
    }

    onPostMessageSuccess(response, dispatch, props) {
      const {
        selectedMessage: { pkMessage } = {},
        getChildrenMessages,
        postMessageSuccess,
      } = this.props;
      postMessageSuccess(response, dispatch, props);
      getChildrenMessages(pkMessage);
    }

    componentDidMount() {
      const { selectedMessage: { pkMessage } = {}, getChildrenMessages } = this.props;
      if (pkMessage) {
        getChildrenMessages(pkMessage);
      }
    }

    componentDidUpdate(prevProps) {
      const { selectedMessage: { pkMessage } = {}, getChildrenMessages } = this.props;

      const { selectedMessage: { pkMessage: prevPkMessage } = {} } = prevProps;

      if (pkMessage !== prevPkMessage) {
        getChildrenMessages(pkMessage);
      }
    }

    render() {
      return (
        <Component
          {...this.props}
          {...this.state}
          onPostMessageSuccess={this.onPostMessageSuccess}
        />
      );
    }
  };

withLoadChildrenMessages.propTypes = {
  Component: PropTypes.element,
};

export default withLoadChildrenMessages;



// WEBPACK FOOTER //
// ./components/inAppMessages/withLoadChildrenMessages.js